export default class MyGamePlanLevelTooltips {
  constructor() {
    this.tooltipTriggers = document.querySelectorAll(
      ".progress-line .status-name.has-tooltip, .progress-line .dot.has-tooltip"
    );

    this.messages = {
      bronze: "",
      silver:
        "Complete 5 actions,<br> join 2 opt-in platforms and apply for 10 campaigns",
      gold: "Win your first deal",
      platinum: "Win 10 deals",
      diamond: "Win 25 deals and refer 3 people through affiliate program",
    };
  }

  bindEvents = () => {
    if (this.tooltipTriggers.length < 1) {
      return;
    }

    this.tooltipTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        const triggerEl = event.currentTarget;
        const levelName = triggerEl.dataset.levelName;
        const message = this.messages[levelName];
        if (message) {
          const tooltipContent = document.querySelector(
            "#mgp-lvl-tooltip-content"
          );
          tooltipContent.innerHTML = message;
          const tooltip = document.querySelector("#mgp-lvl-tooltip");
          this.positionTooltip(triggerEl, event);
          setTimeout(() => {
            tooltip.style.display = "block";
          }, 5);
        }
      });
    });

    window.addEventListener("scroll", this.hideTooltip);

    document.addEventListener("click", (event) => {
      if (
        !event.target.closest("#mgp-lvl-tooltip-content") &&
        !event.target.classList.contains("has-tooltip")
      ) {
        this.hideTooltip();
      }
    });
  };

  hideTooltip = () => {
    const tooltipStyle = document.querySelector("#mgp-lvl-tooltip")?.style || {};
    tooltipStyle.display = "none";
    const tooltipContent = document.querySelector("#mgp-lvl-tooltip-content") || {};
    tooltipContent.innerHTML = "";
  };

  positionTooltip = (trigger, event) => {
    const tooltip = document.querySelector("#mgp-lvl-tooltip");
    const tooltipWidth = 200;
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    const levelName = trigger.dataset.levelName;
    const trLeft = trigger.getBoundingClientRect().left;
    const trWidth = trigger.getBoundingClientRect().width;
    let tooltipTop = mouseY + 10;
    let tooltipLeft = trLeft + trWidth / 2 - tooltipWidth / 2;
    if (levelName === "diamond") {
      tooltipLeft = trLeft - tooltipWidth;
    }

    if (tooltip?.style) {
      tooltip.style.display = "none";
      tooltip.style.left = tooltipLeft + "px";
      tooltip.style.top = tooltipTop + "px";
      const tooltipRect = tooltip.getBoundingClientRect();
      if (tooltipRect.right > window.innerWidth) {
        tooltip.style.left = window.innerWidth - tooltipWidth + "px";
      } else if (tooltipRect.left < 0) {
        tooltip.style.left = "0px";
      }
      tooltip.style.display = "block";
    }
  };
}
